import { useEffect, useState } from 'react';
import img1 from '../assets/slider/1.jpg';
import img2 from '../assets/slider/2.jpg';
import img3 from '../assets/slider/3.jpg';
import img4 from '../assets/slider/4.jpg';
import img5 from '../assets/slider/5.jpg';
import img6 from '../assets/slider/6.png';
import './InstagramSlider.css';

const slides = [img1, img2, img3, img4, img5, img6];
const slideAlts = [
  'Golden retriever playing outdoors by a lake',
  'Two dogs playing together in a park',
  'Golden retriever running through a wildflower meadow',
  'Border collie jumping happily outdoors',
  'Golden retriever relaxing in a garden',
  'Golden retriever puppy resting outdoors',
];

export default function InstagramSlider() {
  const [isPaused, setIsPaused] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const updateMotionPreference = () => setReducedMotion(mediaQuery.matches);
    updateMotionPreference();
    mediaQuery.addEventListener?.('change', updateMotionPreference);

    return () => mediaQuery.removeEventListener?.('change', updateMotionPreference);
  }, []);

  const loopSlides = [...slides, ...slides];

  return (
    <section className="instagram-slider" aria-labelledby="instagram-slider-heading">
      <div className="header-container instagram-slider__header">
        <p className="instagram-slider__eyebrow">#TRILLIUMPUP COMMUNITY</p>
        <h2 id="instagram-slider-heading">Follow The Pack on Instagram</h2>
        <p>Tag @TrilliumPaws to be featured with your furry family member!</p>
      </div>

      <div
        className={`instagram-slider__viewport${isPaused ? ' is-paused' : ''}${reducedMotion ? ' is-static' : ''}`}
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
      >
        <div className="instagram-slider__track">
          {loopSlides.map((image, index) => {
            const slideIndex = index % slides.length;
            return (
              <a
                className="instagram-slider__slide"
                href="https://www.instagram.com/TrilliumPaws"
                target="_blank"
                rel="noopener noreferrer"
                key={`${slideIndex}-${index}`}
              >
                <img src={image} alt={slideAlts[slideIndex]} />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}